export default __webpack_public_path__ + "static/media/shirt.725ca6f0.jpg";